import type { TAwayReason } from '@/services/concierges';

type TBooksColumn = {
  key: string;
  label: string;
  width: string;
};

const CONCIERGES_COPY = {
  title: 'Concierges',
  subtitle: 'Books, workload, and a quiet ear on the threads.',
  booksTitle: 'Books',
  booksPermission: 'members.reassign · manager · super-admin',
  transfer: 'Transfer clients…',
  viewBook: 'View book',
  away: 'Away',
  inactive: 'Inactive',
  until: 'until',
  separator: ' · ',
  emptyTitle: 'No concierges yet.',
  emptyDescription: 'A concierge appears here once they are added in Admin Manage.',
  errorDescription: 'Nothing was loaded. Reload the page or try again in a moment.',
} as const;

const MONITOR_COPY = {
  title: 'Message monitor',
  readOnly: 'Read-only',
  placeholder: 'Pick a thread',
  cross: '×',
  unknownMember: 'Member',
  footnote: 'Monitoring is passive — the Boss never writes into a member thread.',
  emptyThreads: 'No concierge thread has a message yet.',
  emptyMessages: 'This thread has no messages yet.',
} as const;

const TRANSFER_COPY = {
  title: 'Transfer clients',
  unverified: 'Not verified by design',
  description: 'Ownership moves for good and is logged with the before and after. Only an active concierge can take a book.',
  fromLabel: 'From',
  toLabel: 'To',
  membersLabel: 'Members',
  fromPlaceholder: 'Pick a concierge',
  toPlaceholder: 'Pick an active concierge',
  emptyBook: 'This concierge has no active members.',
  confirm: 'Transfer',
  cancel: 'Cancel',
  done: 'transferred',
} as const;

const AWAY_REASON_LABEL: Record<TAwayReason, string> = {
  'vacation': 'Vacation',
  'sick_leave': 'Sick leave',
  'other': '',
};

const BOOKS_COLUMNS: readonly TBooksColumn[] = [
  { key: 'concierge', width: '', label: 'Concierge' },
  { key: 'clients', width: 'w-[112px]', label: 'Clients' },
  { key: 'singles', width: 'w-[100px]', label: 'Singles in play' },
  { key: 'tasks', width: 'w-[84px]', label: 'Open tasks' },
  { key: 'actions', width: 'w-[122px]', label: '' },
];

export type {
  TBooksColumn,
};
export {
  AWAY_REASON_LABEL,
  BOOKS_COLUMNS,
  CONCIERGES_COPY,
  MONITOR_COPY,
  TRANSFER_COPY,
};
